const login = {
    existingUserEmail:false,
    isMissingPhone:null,
    isPrevPath:null,
    noPackageOrEvent:null,
    isInactiveUser:null,
    existingEmailData:null
};

export default login;